// extracted by mini-css-extract-plugin
export default {"p__modal":"Error_p__modal__0Fsqr"};